// extracted by mini-css-extract-plugin
export default {"subtitle":"error-message_subtitle__N7+J+","messageContainer":"error-message_messageContainer__TJqT5","errorMessage":"error-message_errorMessage__ukTCf"};